import { defineStore } from 'pinia';
import { useIndexStore } from './IndexStore';
import TourManagementService from '@/service/TourManagementService';

export const useTourManagementStore = defineStore('tourManagementStore', {
  state: () => ({
    tours: [],
    listToursGateway: [],
    listAllTours: [],
    selectedTours: [],
    listDestination: []
  }),
  getters: {
    getTours: (state) => state.tours,
    getSelectedTours: (state) => state.selectedTours,
    getAllTours: (state) => state.listAllTours,
    selectListGateways: (state) => state.listToursGateway,
    selectListDestination: (state) => state.listDestination,
    getUrlUploadFile: () => {
      const Service = new TourManagementService();
      return Service.getUrlPreview();
    },
    getUrlUploadFileTour: () => {
      const Service = new TourManagementService();
      return Service.getUrlPreviewTour();
    }
  },

  actions: {
    async getGateways() {
      const Service = new TourManagementService();
      try {
        const res = await Service.getTourCombinationGateway();
        if (res) {
          this.updateTourCombinationGateway(res.data);
        }
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },

    updateTour(payload: any) {
      this.tours = payload;
    },

    updateSelectedTours(payload: any) {
      this.selectedTours = payload;
    },

    updateListAllTours(payload: any) {
      this.listAllTours = payload;
    },

    updateTourCombinationGateway(payload: any) {
      this.listToursGateway = payload;
    },

    updateTourCombinationDestination(payload: any) {
      this.listDestination = payload;
    },

    getTourGateway() {
      const Service = new TourManagementService();
      return Service.getTourGateway();
    },

    addTourGateway(payload: any) {
      const Service = new TourManagementService();
      return Service.addTourGateway(payload);
    },

    editTourGateway(payload: any) {
      const Service = new TourManagementService();
      return Service.editTourGateway(payload);
    },

    deleteTourGateway(payload: any) {
      const Service = new TourManagementService();
      return Service.deleteTourGateway(payload);
    },

    getListManagementTour() {
      const Service = new TourManagementService();
      return Service.getListManagementTour();
    },

    getTourInfo(ttsCode: string) {
      const Service = new TourManagementService();
      return Service.getTourInfo(ttsCode);
    },

    addTourDetail(payload: any) {
      const Service = new TourManagementService();
      return Service.addTourDetail(payload);
    },

    editTourDetail(payload: any) {
      const Service = new TourManagementService();
      return Service.editTourDetail(payload);
    },

    deleteTourDetail(payload: any) {
      const Service = new TourManagementService();
      return Service.deleteTourDetail(payload);
    },

    addNote(payload: any) {
      const Service = new TourManagementService();
      return Service.addNote(payload);
    },

    getNotes(payload: any) {
      const Service = new TourManagementService();
      return Service.getNotes(payload);
    },

    searchTourAuto(payload: any) {
      const Service = new TourManagementService();
      return Service.searchTourAuto(payload);
    },

    addDataAutoSearch(payload: any) {
      const Service = new TourManagementService();
      return Service.addDataAutoSearch(payload);
    },

    getTourCombinationGateway() {
      const Service = new TourManagementService();
      return Service.getTourCombinationGateway();
    },

    getTourCombinationDestByGateCode(gateCode: string) {
      const Service = new TourManagementService();
      return Service.getTourCombinationDestByGateCode(gateCode);
    },

    getTourCombinationGatewayByDestCode(payload: any) {
      const Service = new TourManagementService();
      return Service.getTourCombinationGatewayByDestCode(payload);
    },

    getTourDetail(payload: any) {
      const Service = new TourManagementService();
      return Service.getTourDetail(payload);
    },

    importTourGateDes(payload: any) {
      const Service = new TourManagementService();
      return Service.importTourGateDes(payload);
    },

    getVersionRevertTourGateDes(type: string) {
      const Service = new TourManagementService();
      return Service.getVersionRevertTourGateDes(type);
    },

    getPreviewFileTourGateDes(fileName: string) {
      const Service = new TourManagementService();
      return Service.getPreviewFileTourGateDes(fileName);
    },

    getPreviewFileTourDetail(fileName: string) {
      const Service = new TourManagementService();
      return Service.getPreviewFileTourDetail(fileName);
    },

    revertFileTourGateDes(fileName: string) {
      const Service = new TourManagementService();
      return Service.revertFileTourGateDes(fileName);
    },

    revertFileTourDetail(fileName: string) {
      const Service = new TourManagementService();
      return Service.revertFileTourDetail(fileName);
    },

    importTourDetail(payload: any) {
      const Service = new TourManagementService();
      return Service.importTourDetail(payload);
    }
  }
});
